enum JourneyStatus {
  OPEN = 'OPEN',
  PREPARING_FOR_FITTING_APPOINTMENT = 'PREPARING_FOR_FITTING_APPOINTMENT',
  IN_TRIAL = 'IN_TRIAL',
  CLOSED = 'CLOSED',
}

export { JourneyStatus }
